export default __webpack_public_path__ + "static/media/arrow-right.a1c26fc1.svg";